<template>
  <div :id="'chart_'+uuid">
    <div class="chart-container" style="position: relative;" :style="`width: ${size.width}; height: ${size.height};`">
      <canvas :id="uuid" :width="size.width" :height="size.height" />
    </div>
  </div>
</template>

<script>
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Chart } from "chart.js/auto";

export default {
  name: "88e0fa65-e328-11ed-8761-c85acf022408",
  props: ['chart', 'size', 'title', 'uuid'],
  mounted() {
    this.canvas = document.getElementById(this.uuid).getContext('2d')
    this.make_chart()
  },
  data() {
    return {
      canvas: null,
      graph: null,
      prepared_data: [],
      objects: [],
      errors: []
    }
  },
  computed: {
    report_data() {
      return this.chart.report_data
    }
  },
  watch: {
    report_data() {
      this.update_chart()
    }
  },
  methods: {
    make_chart: function () {
      if (this.canvas) {
        this.update_data()
        this.graph = new Chart(this.canvas, {
          type: 'bar',
          plugins: [ChartDataLabels],
          data: {
            labels: this.objects,
            datasets: [
              {
                data: this.errors
              }
            ]
          },
          options: {
            scales: {
              y: {
                beginAtZero: true,
                title: {
                  display: true,
                  text: 'Кол-во неисправностей'
                },
              }
            },
            plugins: {
              autocolors: {
                mode: 'data'
              },
              datalabels: {
                color: '#000',
                anchor: 'end',
                align: 'end'
              },
              legend: {
                display: false
              },
            }
          }
        })
      }
    },
    update_data: function () {
      this.prepared_data = []
      this.objects = []
      this.errors = []

      for (let element of this.chart.report_data) {
        if (!this.prepared_data.find(object => object.name === element['ФизОбъектПРЕДСТАВЛЕНИЕ'])) {
          this.prepared_data.push({
            name: element['ФизОбъектПРЕДСТАВЛЕНИЕ'],
            errors: getErrors(this.chart.report_data, element['ФизОбъектПРЕДСТАВЛЕНИЕ'])
          })
        }
      }

      this.prepared_data.sort(function (a, b) {
        return parseFloat(a.errors) - parseFloat(b.errors);
      })

      this.prepared_data.reverse()

      for (let element of this.prepared_data) {
        this.objects.push(element.name)
        this.errors.push(element.errors)
      }

      function getErrors(data, object_name) {
        let object_data = data.filter(element => element['ФизОбъектПРЕДСТАВЛЕНИЕ'] === object_name)
        let tmp = 0
        if (object_data) {
          for (let element of object_data) {
            tmp = tmp + element['Неисправности']
          }
        }
        return tmp
      }
    },
    update_chart: function () {
      this.update_data()
      this.graph.destroy()
      this.make_chart()
    }
  }
}
</script>